// import BaseFormPresenter from "../../../../base/BaseFormPresenter";

import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";
import { findObjectUseCase, upsertUseCase } from "../../../../usecases/object";

class NoticeTemplateFormPresenter extends BaseFormPresenter {
  onChange(value, field) {
    this.change[field] = value;
    this.object[field] = value;
    this.view.setObject(this.object);
  }

  fields = ["region", "office", "division", "section", "unit", "cluster"];

  getLastNonEmptyField = (source) => {
    let result = "";
    let index = -1;

    this.fields.forEach((field, i) => {
      if (source[field] && source[field] !== "") {
        result = source[field];
        index = i;
      }
    });

    return { result, index };
  };
  async save() {
    const collection = this.view.getCollectionName();
    console.log("OBEJCT: ", this.change);
    if (this.object.id) {
      this.change.id = this.object.id;
    } else {
      this.change.acl = this.view.getAcl();
    }
    try {
      await this.upsertUseCase.execute(collection, this.change);
      this.showSuccess("Success");
      this.change = {};
    } catch (error) {
      throw error; // rethrow the error to be caught by the caller
    }
  }
}

export default NoticeTemplateFormPresenter;
